import './erro.css';
import { Link } from 'react-router-dom';

export default function Erro() {
    return(
        <div className='containerErro'>
            <h2>404</h2>
            <span>Pagina não encontrada</span>

            <Link to='/projetos'>
                Voltar para Projetos
            </Link>

            <Link to='/'>
                Voltar para Pagina Inicial
            </Link>
        </div>
    );
}